(() => {
  const formatMoney = (cents) => {
    return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: Shopify.currency.active || 'EUR' });
  };

  const updateProgress = (el, totalPriceCents) => {
    const threshold = Number(el.dataset.freeShippingThreshold || 12000);
    const ratio = Math.max(0, Math.min(100, (totalPriceCents / threshold) * 100));
    const missing = Math.max(0, threshold - totalPriceCents);

    const fill = el.querySelector('[data-progress-fill]');
    if (fill) fill.style.width = `${ratio}%`;

    const label = el.querySelector('[data-progress-label]');
    if (label) {
      label.textContent = missing > 0
        ? `Plus que ${formatMoney(missing)} pour la livraison offerte`
        : 'Livraison offerte debloquee';
    }
  };

  const mount = async () => {
    const bars = document.querySelectorAll('[data-cart-progress]');
    if (!bars.length) return;

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      const cart = await response.json();
      bars.forEach((bar) => updateProgress(bar, cart.total_price || 0));
    } catch (error) {
      console.error('Unable to update cart progress', error);
    }
  };

  document.addEventListener('DOMContentLoaded', mount, { once: true });
})();
